// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StaticLayout_wrapper__LjNWl","heading":"StaticLayout_heading__mQGhH","header":"StaticLayout_header__wzJAT","description":"StaticLayout_description__dMN08"};